





















import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Modal from '@/components/Modal.vue'
import DateInput2 from '@/components/inputs/DateInput2.vue'
import TextArea from '@/components/inputs/TextArea.vue'
import { UserModule } from '@/store/modules/user.module'
import { EAlertStatus } from '@zunta/configurations'

@Component({
  props: {
    alert: {
      type: Object,
      required: true
    }
  },
  components: {
    Modal,
    DateInput2,
    TextArea
  }
})
export default class AlertLookIntoModal extends Vue {
  userModuleInstance: UserModule = getModule(UserModule, this.$store);
  comments: string = '';
  enableValidation: boolean = false;

  validate () {
    return !!this.comments
  }

  async submit () {
    this.enableValidation = true
    if (this.validate()) {
      await this.userModuleInstance.changeAlertStatus({
        alertId: this.$props.alert.id,
        data: {
          comments: this.comments,
          status: EAlertStatus.LOOKED_INTO
        }
      })
      this.$emit('close')
    }
  }
}
